import { render, staticRenderFns } from "./athletics.vue?vue&type=template&id=742cb03c&"
import script from "./athletics.vue?vue&type=script&lang=js&"
export * from "./athletics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports